var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "data-profiling" }, [
    _c("div", { staticClass: "title" }, [_vm._v("数据概况")]),
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "accumulate-activation" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "head" }, [_vm._v("累计激活设备数")]),
          _c("div", { staticClass: "num" }, [
            _vm._v(_vm._s(_vm.devicesData.allActivateDevice)),
          ]),
        ]),
        _c("div", { staticClass: "right" }),
      ]),
      _c("div", { staticClass: "accumulate-register" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "head" }, [_vm._v("累计注册用户数")]),
          _c("div", { staticClass: "num" }, [
            _vm._v(_vm._s(_vm.devicesData.allRegistrant)),
          ]),
        ]),
        _c("div", { staticClass: "right" }),
      ]),
      _c("div", { staticClass: "today-activation" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "head" }, [_vm._v("今日激活设备数")]),
          _c("div", { staticClass: "num" }, [
            _vm._v(_vm._s(_vm.devicesData.tactivateDevice)),
          ]),
        ]),
        _c("div", { staticClass: "right" }, [
          _vm._v("昨日：" + _vm._s(_vm.devicesData.yactivateDevice)),
        ]),
      ]),
      _c("div", { staticClass: "today-register" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "head" }, [_vm._v("今日注册数")]),
          _c("div", { staticClass: "num" }, [
            _vm._v(_vm._s(_vm.devicesData.tregistrant)),
          ]),
        ]),
        _c("div", { staticClass: "right" }, [
          _vm._v("昨日：" + _vm._s(_vm.devicesData.yregistrant)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "accumulate-activation-box" }, [
      _c("div", { staticClass: "head" }, [_vm._v("累计激活设备数")]),
      _c("div", {
        ref: "accumulateActivationEcharts",
        staticStyle: { width: "100%", height: "420px" },
      }),
    ]),
    _c("div", { staticClass: "accumulate-register-box" }, [
      _c("div", { staticClass: "head" }, [_vm._v("累计注册用户数")]),
      _c("div", {
        ref: "accumulateRegisterEcharts",
        staticStyle: { width: "100%", height: "420px" },
      }),
    ]),
    _c("div", { staticClass: "today-activation-box" }, [
      _c("div", { staticClass: "head" }, [_vm._v("今日激活设备数")]),
      _c("div", {
        ref: "todayActivationEcharts",
        staticStyle: { width: "100%", height: "420px" },
      }),
    ]),
    _c("div", { staticClass: "today-register-box" }, [
      _c("div", { staticClass: "head" }, [_vm._v("今日注册用户数")]),
      _c("div", {
        ref: "todayRegisterEcharts",
        staticStyle: { width: "100%", height: "420px" },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }